import apiClient from './client';

export interface ProviderEvent {
  id: string;
  providerId?: string | null;
  source: string;
  eventType: string;
  eventId: string;
  businessExternalId?: string | null;
  providerStatus?: string | null;
  signatureValid: boolean;
  processingStatus: string;
  deliveryCount: number;
  processingAttempts: number;
  businessObjectType?: string | null;
  businessObjectId?: string | null;
  ledgerTransactionId?: string | null;
  incomingProviderReturnId?: string | null;
  processingError?: string | null;
  escalationCode?: string | null;
  receivedAt: string;
  lastReceivedAt: string;
  processingStartedAt?: string | null;
  processedAt?: string | null;
  escalatedAt?: string | null;
  ignoredAt?: string | null;
}

export interface ProviderEventFilter {
  providerId?: string;
  eventType?: string;
  status?: string;
  signatureValid?: boolean;
  receivedFrom?: string;
  receivedTo?: string;
  limit?: number;
}

export const providerEventsApi = {
  async list(filter: ProviderEventFilter = {}) {
    const { data } = await apiClient.get<ProviderEvent[]>('/admin/provider-events', { params: filter });
    return data;
  },
  async getPayload(id: string) {
    const { data } = await apiClient.get<string>(`/admin/provider-events/${id}/payload`, { responseType: 'text' });
    return data;
  },
  async problemCounts() {
    const { data } = await apiClient.get<Array<{ providerId: string; count: number }>>('/admin/provider-events/summary/problem-counts');
    return data;
  },
  async escalatedCounts() {
    const { data } = await apiClient.get<Array<{ providerId: string; count: number }>>('/admin/provider-events/summary/escalated-counts');
    return data;
  },
  async escalated(providerId?: string, limit = 100) {
    const { data } = await apiClient.get<ProviderEvent[]>('/admin/provider-events/escalated', { params: { providerId, limit } });
    return data;
  },
  retry(id: string) {
    return apiClient.post(`/admin/provider-events/${id}/retry`);
  },
  ignore(id: string, reason?: string) {
    return apiClient.post(`/admin/provider-events/${id}/ignore`, { reason });
  }
};
